module.exports = __webpack_public_path__ + "static/media/icon_investment-research.5caf8efb.svg";